import Secretaria from '../components/secretaria/Index'
import Campamentos from '../components/secretaria/campamento/Campamentos'
import Listados from '../components/secretaria/personas/Listados'
import Unrevised from '../components/secretaria/Unrevised'
import Unpaided from '../components/secretaria/campamento/Unpaided'
import Secreto from '../components/secretaria/personas/Secreto'
import Datos from '../components/secretaria/personas/Datos'
import Pagados from '../components/secretaria/Pagados'
import DiaFamilias from '../components/secretaria/personas/DiaFamilias.vue'

import InscripcionesRecibo from '../components/secretaria/InscripcionesRecibo'
import ResubirDocumento from '../components/secretaria/ResubirDocumento'

import Inscripciones from '../components/secretaria/Inscripciones'
import Soon from '../components/Soon'
import Login from '../components/Login'
import Logout from '../components/Logout'

export default[
    {
        path: '*',
        redirect: '/',
        tab: false,
    },
    //En periodo de inscripciones poner redirect /soon en lugar de redirect /inscripcion
    {
        path: '/',
        name: 'home',
        //redirect: '/inscripcion',
        redirect: '/soon',
        icon: 'home',
        color: 'orange darken-1',

    },
    {
        name:'soon',
        path: '/soon',
        component: Soon,
        color: 'orange darken-1',
    },
    {
        path: '/inscripcion',
        component: Inscripciones,
        color: 'orange darken-1'

    },
    {
        path: '/fuera_de_plazo',
        name: 'fdp',
        component: Inscripciones,
        icon: 'home',
        color: 'orange darken-1',

    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        color: 'orange darken-1',
    },
    {
        name:'logout',
        path: '/logout',
        component: Logout,
        color: 'orange darken-1',
    },
    // {
    //     name:'nuevo',
    //     path: '/nuevo',
    //     component: Nuevo,
    //     color: 'orange darken-1',
    // },
    // {
    //     name:'encuesta',
    //     path: '/encuesta',
    //     component: Encuesta,
    //     color: 'orange darken-1',
    // },
    {
        path: '/recibo',
        tab: false,
        name: 'recibo',
        component: InscripcionesRecibo,
        icon: 'home',
        color: 'orange darken-1',
        props: (route) => ({ id: route.query.i })
    },
    {
        path: '/resubir',
        tab: false,
        name: 'resubir',
        component: ResubirDocumento,
        icon: 'home',
        color: 'orange darken-1',
        props: (route) => ({ 
            idPerson: route.query.idPerson,
            type : route.query.type
        })
    },
    {
        path: '/secretaria',
        component: Secretaria,
        icon: 'secretaria',
        color: 'teal darken-1',
        meta: {
            requiresAuth: true,
            requiresSecretaria: true
        },
        children: [
            {
                path: '',
                name: 'secretaria',
                component: Campamentos
            },
            {
                path: 'unrevised',
                name: 'unrevised',
                component: Unrevised
            },
            {
                path: 'unpaided',
                name: 'unpaided',
                component: Unpaided
            },
            {
                path: 'secreto',
                name: 'secreto',
                component: Secreto,    
            },
            {
                path: 'diafamilias',
                name: 'diafamilias',
                component: DiaFamilias,
            },
            {
                path: 'datos',
                name: 'datos',
                component: Datos,    
            },
            {
                path: 'pagados',
                name: 'pagados',
                component: Pagados,
            },
            {
                name: 'campamentos',
                path: 'campamentos',
                component: Campamentos
            },
            {
                name: 'listados',
                path: 'listados/:unidad',
                component: Listados,
                props: true
            },
        ]
    }
]
